import React, { useState, useEffect } from 'react';
import { injectIntl } from "react-intl";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'Components';
/*********************************************************
 * Controls
 *********************************************************/
import Popover from '@mui/material/Popover';

/*********************************************************
 * Icons
 *********************************************************/
import MapIcon from '@mui/icons-material/Map';


/*********************************************************
 * Style
 *********************************************************/
import './style.scss';
import { useIntl } from 'react-intl';
import { getPreferences, savePreference } from "Redux/actions";

/*********************************************************
 * Thumbnail SVG previews for each map type
 *********************************************************/
const ThumbnailMap = () => (
  <svg viewBox="0 0 120 84" xmlns="http://www.w3.org/2000/svg">
    <rect width="120" height="84" fill="#f0ede4" />
    {/* park / green area */}
    <path d="M0 50 Q15 40 35 48 T70 42 T120 46 V84 H0Z" fill="#c8e6c0" opacity="0.45" />
    {/* water */}
    <path d="M85 0 Q95 12 88 25 Q80 38 90 50" stroke="#aad4e5" strokeWidth="3.5" fill="none" />
    {/* major road */}
    <path d="M0 28 Q30 22 60 30 T120 24" stroke="#fdd835" strokeWidth="3" fill="none" />
    {/* secondary roads */}
    <path d="M25 0 V84" stroke="#fff" strokeWidth="2" />
    <path d="M55 0 V84" stroke="#fff" strokeWidth="1.5" opacity="0.7" />
    <path d="M90 0 V84" stroke="#fff" strokeWidth="2" />
    <path d="M0 55 H120" stroke="#fff" strokeWidth="1.5" opacity="0.7" />
    <path d="M0 15 H120" stroke="#fff" strokeWidth="1.2" opacity="0.5" />
    {/* building blocks */}
    <rect x="30" y="5" width="20" height="12" rx="1" fill="#e0ddd4" opacity="0.6" />
    <rect x="60" y="35" width="18" height="10" rx="1" fill="#e0ddd4" opacity="0.5" />
    <rect x="5" y="60" width="15" height="10" rx="1" fill="#e0ddd4" opacity="0.4" />
  </svg>
);

const ThumbnailSatellite = () => (
  <svg viewBox="0 0 120 84" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="satGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#2c5234" />
        <stop offset="50%" stopColor="#1e3d28" />
        <stop offset="100%" stopColor="#162e1e" />
      </linearGradient>
    </defs>
    <rect width="120" height="84" fill="url(#satGrad)" />
    {/* field patches */}
    <rect x="0" y="0" width="45" height="35" fill="#345a3a" opacity="0.6" />
    <rect x="48" y="0" width="72" height="30" fill="#2a5030" opacity="0.5" />
    <rect x="0" y="38" width="55" height="46" fill="#2e5434" opacity="0.4" />
    <rect x="58" y="33" width="62" height="51" fill="#274828" opacity="0.5" />
    {/* roads as dark lines */}
    <path d="M46 0 V84" stroke="#1a1a1a" strokeWidth="1.5" opacity="0.4" />
    <path d="M0 36 H120" stroke="#1a1a1a" strokeWidth="1.5" opacity="0.4" />
    {/* building clusters */}
    <rect x="15" y="12" width="14" height="10" fill="#5a5a4e" opacity="0.35" rx="1" />
    <rect x="65" y="45" width="18" height="12" fill="#5a5a4e" opacity="0.3" rx="1" />
    <rect x="85" y="8" width="10" height="8" fill="#5a5a4e" opacity="0.25" rx="1" />
  </svg>
);

const ThumbnailHybrid = () => (
  <svg viewBox="0 0 120 84" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="hybGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#2c5234" />
        <stop offset="100%" stopColor="#1a3520" />
      </linearGradient>
    </defs>
    <rect width="120" height="84" fill="url(#hybGrad)" />
    <rect x="0" y="0" width="50" height="38" fill="#345a3a" opacity="0.5" />
    <rect x="55" y="35" width="65" height="49" fill="#274828" opacity="0.45" />
    {/* labeled roads */}
    <path d="M0 30 Q35 22 70 30 T120 26" stroke="#fdd835" strokeWidth="2.5" fill="none" opacity="0.85" />
    <path d="M30 0 V84" stroke="rgba(255,255,255,0.45)" strokeWidth="1.8" />
    <path d="M75 0 V84" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" />
    <path d="M0 58 H120" stroke="rgba(255,255,255,0.35)" strokeWidth="1.2" />
    {/* road labels */}
    <text x="38" y="24" fill="white" fontSize="5.5" fontFamily="sans-serif" fontWeight="bold" opacity="0.8">Main St</text>
    <text x="78" y="54" fill="white" fontSize="4.5" fontFamily="sans-serif" opacity="0.6">Oak Ave</text>
    {/* buildings */}
    <rect x="10" y="40" width="12" height="9" fill="#5a5a4e" opacity="0.3" rx="1" />
    <rect x="85" y="10" width="15" height="10" fill="#5a5a4e" opacity="0.25" rx="1" />
  </svg>
);

const ThumbnailTerrain = () => (
  <svg viewBox="0 0 120 84" xmlns="http://www.w3.org/2000/svg">
    <rect width="120" height="84" fill="#e8e3d0" />
    {/* elevation shading */}
    <path d="M0 60 Q20 40 45 50 T80 35 T120 42 V84 H0Z" fill="#c5d9a0" opacity="0.5" />
    <path d="M0 70 Q30 55 60 65 T120 58 V84 H0Z" fill="#b0cb88" opacity="0.35" />
    {/* contour lines */}
    <path d="M0 25 Q25 15 50 22 T100 18 L120 20" stroke="#b3a882" strokeWidth="0.8" fill="none" opacity="0.5" />
    <path d="M0 35 Q30 25 60 32 T120 28" stroke="#b3a882" strokeWidth="0.7" fill="none" opacity="0.4" />
    <path d="M0 45 Q20 38 50 42 T90 38 L120 40" stroke="#b3a882" strokeWidth="0.7" fill="none" opacity="0.35" />
    {/* mountain peaks */}
    <path d="M20 30 L32 12 L44 30Z" fill="#d2c9a8" opacity="0.35" />
    <path d="M65 25 L80 8 L95 25Z" fill="#d2c9a8" opacity="0.3" />
    <circle cx="32" cy="14" r="1.5" fill="#999" opacity="0.5" />
    <circle cx="80" cy="10" r="1.5" fill="#999" opacity="0.5" />
    {/* roads */}
    <path d="M0 52 Q40 44 80 50 T120 46" stroke="#fff" strokeWidth="2" fill="none" opacity="0.7" />
    <path d="M50 0 V84" stroke="#fff" strokeWidth="1.5" opacity="0.5" />
  </svg>
);

const THUMBNAILS = {
  roadmap: ThumbnailMap,
  satellite: ThumbnailSatellite,
  hybrid: ThumbnailHybrid,
  terrain: ThumbnailTerrain,
};

/*********************************************************
 * Layer toggle component for the realtime map
 ********************************************************/
const LayerToggle = (props) => {

  const { preferencesUser, returnServer } = useSelector(state => state.preferencesRedux);
  const { authenticatedId } = useSelector(state => state.securityRedux);
  /********************************************************
   * Define const
   ********************************************************/
  const { messages } = useIntl()
  const keyPreferences = "mapSettings"
  const dispatch = useDispatch();
  const [isLegendsOpened, setIsLegendsOpened] = useState()
  const [mapType, setMapType] = useState('roadmap')
  const [preferences, setPreferences] = useState(null)

  const Layers = [
    { name: messages['Map_layer'], id: 'G_NORMAL_MAP', key: 'roadmap' },
    { name: messages['Satellite_layer'], id: 'G_SATELLITE_MAP', key: 'satellite' },
    { name: messages['Hybrid_layer'], id: 'G_HYBRID_MAP', key: 'hybrid' },
    { name: messages['Terrain_layer'], id: 'G_TERRAIN_MAP', key: 'terrain' },
  ];

  useEffect(() => {
    if (authenticatedId) {
      dispatch(getPreferences({ entityName: "User", entityId: authenticatedId, force: true }))
    }
  }, [])

  useEffect(() => {
    if (preferencesUser) {
      let preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === keyPreferences);
      let preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}";
      preferencesJSON = JSON.parse(preferencesJSON);

      loadPreferencesDefault(preferencesJSON)
      setPreferences(preferencesJSON)
    }
  }, [returnServer]);

  // Keep local preferences state in sync whenever any component saves mapSettings
  // (e.g. WeatherToggle). Without this, savePreferences spreads from a stale snapshot
  // and overwrites concurrent weather/other preference changes.
  useEffect(() => {
    if (preferencesUser) {
      const preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === keyPreferences);
      const preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}";
      setPreferences(JSON.parse(preferencesJSON));
    }
  }, [preferencesUser]);

  /********************************************************
   * Event to close legend component
   ********************************************************/
  const handleClose = () => {
    setIsLegendsOpened(null)
  };

  /********************************************************
   * Event to open legend component
   ********************************************************/
  const handleOpenLegend = (event) => {
    setIsLegendsOpened(event.currentTarget)
  }

  /********************************************************
   * Configure the maptype preferences by default
   ********************************************************/
  const loadPreferencesDefault = (preferences) => {
    if (preferences) {
      let value = null
      Object.keys(preferences)?.forEach((key) => {
        if (key == 'mapType') {
          value = preferences[key];
        }
      })
      if (value) {
        const layer = Layers.find((item) => item.id == value || item.key == value)
        value = layer ? layer.key : 'roadmap'
      } else {
        value = 'roadmap'
      }
      if (props.changeMapType) {
        props.changeMapType(value)
      }
      setMapType(value)
    }
  }

  /********************************************************
  * Save the preferences
  ********************************************************/
  const savePreferences = (paramMapType) => {
    if (authenticatedId) {
      let preferencesToSave = { ...preferences, mapType: paramMapType }
      if (preferencesToSave) {
        setPreferences(preferencesToSave)
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: keyPreferences, preferenceValue: preferencesToSave }));
      }
    }
  }

  /********************************************************
   * Handle layer selection
   ********************************************************/
  const handleSelectLayer = (layerKey) => {
    setMapType(layerKey)
    if (props.changeMapType) {
      props.changeMapType(layerKey)
    }
    savePreferences(layerKey)
  }

  /********************************************************
   * Return the legend component
   ********************************************************/
  const open = Boolean(isLegendsOpened);
  const id = open ? 'simple-popover' : undefined;
  const styleButton = open ? { color: '#0098DC' } : {}
  return (
    <>
      <Tooltip placement="left" title={messages['maputilities_layer']} >
        <button
          onClick={handleOpenLegend}
        >
          <MapIcon style={styleButton}></MapIcon>
        </button>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={isLegendsOpened}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="layer-selector">
          <div className="layer-selector__header">
            {messages['maputilities_layer']}
          </div>
          <div className="layer-selector__grid">
            {Layers.map((item) => {
              const Thumb = THUMBNAILS[item.key];
              const isSelected = mapType === item.key;
              return (
                <button
                  key={item.key}
                  className={`layer-selector__card${isSelected ? ' layer-selector__card--active' : ''}`}
                  onClick={() => handleSelectLayer(item.key)}
                  type="button"
                >
                  <div className="layer-selector__thumbnail">
                    {Thumb && <Thumb />}
                  </div>
                  <span className="layer-selector__label">{item.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      </Popover>
    </>
  )
}

const mapStateToProps = ({ securityRedux }) => {
  const { authenticatedId } = securityRedux;
  return {
    authenticatedId
  };
}

export default injectIntl(
  connect(mapStateToProps, {})(LayerToggle),
);
